import { useMemo } from 'react'
import { Money } from '@klear/money'
import type { WizardStepComponentProps } from '@klear/ui/wizard/flow'
import type { DisbursementStepCtx } from '@/app/disbursements/outlet-context'

export default function ReviewStep({ ctx }: WizardStepComponentProps<DisbursementStepCtx>) {
  const { state, disbursableAdvances, hasMixedCurrency } = ctx

  const selectedSet = useMemo(() => new Set(state.selectedAdvanceIds), [state.selectedAdvanceIds])
  const selectedRows = useMemo(
    () => disbursableAdvances.filter((a) => selectedSet.has(a.id)),
    [disbursableAdvances, selectedSet]
  )
  const total = useMemo(() => Money.sum(selectedRows.map((a) => a.purchasePrice)), [selectedRows])
  const totalFormatted = total.toString()

  return (
    <div className="space-y-4 w-full">
      <p className="text-sm text-muted-foreground">Review and disburse.</p>
      <dl className="space-y-1 text-sm">
        <div className="flex justify-between gap-4">
          <dt className="text-muted-foreground">Advances</dt>
          <dd>{selectedRows.length} selected</dd>
        </div>
        {selectedRows.map((row) => (
          <div key={row.id} className="flex justify-between gap-4 pl-2">
            <dt className="text-muted-foreground">Offer {row.idDisplay || `#${row.id}`}</dt>
            <dd>{row.purchasePrice.toString()}</dd>
          </div>
        ))}
        <div className="flex justify-between gap-4 font-medium border-t pt-2 mt-2">
          <dt>Total</dt>
          <dd>{totalFormatted}</dd>
        </div>
      </dl>
      {hasMixedCurrency && (
        <p className="text-sm text-destructive">
          Selected advances span multiple currencies. Disbursements are single-currency — deselect the off-currency
          advances to continue.
        </p>
      )}
    </div>
  )
}
